import { render, staticRenderFns } from "./newaccount.vue?vue&type=template&id=be57457c&"
import script from "./newaccount.vue?vue&type=script&lang=js&"
export * from "./newaccount.vue?vue&type=script&lang=js&"
import style0 from "./newaccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports